/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable complexity */
/* eslint-disable max-lines */
import { Inject, Injectable } from '@angular/core';
import { ServiceHistoryLabels } from '../../components/myfleet/sub-modules/equipment-detail/definitions';
import { Address, AssignedLocation, LocationPrimaryGrid, LoggedInLocation, LoggedInUser, Message, Role, StateProvince, Token, TokenData } from './shared-interface';
import { DateConverterService } from '../date-converter/date-converter.service';
import { forIn as lodashForIn } from 'lodash';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { AuthState, ServiceManagementAddress } from '../../components/auth/definitions';
import { AbstractControl } from '@angular/forms';
import { EnvironmentRef } from 'projects/tmhna-portal/src/environments/interfaces';
import { expEnvironmentRef } from '../../injection-tokens/environment.injection-token';
import { Control, ControlType, FieldType, KngHeaderObjState, KngValueListState, KngValueObjState, SortOrder } from 'kinetic-angular';
import { BreadCrumb, FieldName, LanguageCode, CompanyLocationsTableHeader, FileName, CountryCode, states, provinces, AssignedUserTableHeader, InviteUserheader, InviteBulkUserheader, BulkEquipmentHeader, AddBulkEquipmentDownloadReportTemplate, AddBulkEquipmentNonToyotaDownloadReportTemplate, RemoveBulkEquipmentHeader, Icons, ReviewListDownloadHeader } from './shared-enums';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ApiService } from '../api/api.service';
import { ApiResponse } from '../../definitions/api-response.interface';
import { map } from 'rxjs/operators';
import { SharedUtilService } from './shared-util.service';
import { GridModel } from '../../components/service-management/components/service-management-page';
import { DownloadCompanyLocation, ValidateRemoveLocResponse } from '../../components/account-settings/definitions/account-settings.interface';
import { CommonErrorService, CommonErrorState } from '../../components/common-error';
import { canadaZipFormat, individualUserRoleId, nullCheckValue, batteryStateOfChargeNullValue, individualUserPermissionMessage, accountManagerRoleId } from './shared-constants';
import { BulkEquipmentDownloadReportTemplate, BulkEquipmentNonToyotaDownloadReportTemplate, ChangeRequestHeaderLabel, DownloadReportTemp, ReviewListDownloadTemp, ReviewListHeader } from '../../components/myfleet/definitions/myfleet.interface';
import { Router } from '@angular/router';
import { LoggerService } from '../logger/logger.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DownloadUserListData } from '../../components/location-management/sub-modules/add-new-location/definitions/add-new-location.interface';
import { MyQuotesGridListLabel } from '../../components/my-quotes';
import { ResponseDealerAddress } from '../../components/order-management/sub-modules/equipment-order-details/definitions/equipment-order-details.interface';
import { SharedFactoryDataService } from './shared-factory-data.service';
import { Image } from '../../services/shared/shared-interface';
export type PrimitiveType = number | string | boolean;
export type SomeKeyValType = { [key: string]: PrimitiveType };

@Injectable({
	providedIn: 'root'
})
export class SharedService
{
	date: string = '';
	objectUrl!: string;
	locationNames: Control[] = [];
	locationNamesArr: string[] = [];
	companyLocationsHeader: any = CompanyLocationsTableHeader;
	bulkEquipmentHeader: any = BulkEquipmentHeader;
	addBulkEquipmentDownloadReportTemplate: any = AddBulkEquipmentDownloadReportTemplate;
	addBulkEquipmentNonToyotaDownloadReportTemplate: any = AddBulkEquipmentNonToyotaDownloadReportTemplate;
	removeBulkEquipmentHeader: any = RemoveBulkEquipmentHeader;
	assignedUserTableHeader: any = AssignedUserTableHeader;
	inviteUserheader: any = InviteUserheader;
	inviteBulkUserheader: any = InviteBulkUserheader;
	reviewListDownloadHeader: any = ReviewListDownloadHeader;
	coperateConvertFlag:boolean = true;
	validateRemoveLocResponse$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public reviewListPresent$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	validateRemoveLocResponse: ValidateRemoveLocResponse = {
		isLastLocation: false,
		identifiedUsers: []
	};
	locationId$: BehaviorSubject<string> = new BehaviorSubject<string>('');
	private readonly userName$: BehaviorSubject<string> = new BehaviorSubject<string>('');
	get userNameObservable$(): Observable<string>
	{
		return this.userName$;
	}
	get userName(): string
	{
		return this.userName$.value;
	}
	set updatedUserNameState(value: string)
	{
		this.userName$.next(value);
	}

	constructor(
		public dateService: DateConverterService,
		public localStorageService: LocalStorageService,
		private readonly apiService: ApiService,
		private readonly sharedUtilService: SharedUtilService,
		public loggerService: LoggerService,
		private errorService: CommonErrorService,
		@Inject(expEnvironmentRef) readonly environmentRef: EnvironmentRef
	)
	{
		this.getLocationValues();
	}

	truncate(input: string, charactersToTruncate: number)
	{
		if (input.length > charactersToTruncate)
		{
			return input.substring(0, charactersToTruncate) + '...';
		}
		return input;
	};

	public nullValueHandler(value: string): string
	{
		return (value !== null && value !== undefined && value.toString().trim() !== '') ? value : nullCheckValue;
	}
	public nullLocationHandler(value: string): string
	{
		return (value !== null && value !== undefined && value.toString().trim() !== '' && value !== 'null, null') ? value : nullCheckValue;
	}
	public nullDateHandler(value: string): string
	{
		return (value !== null && value !== undefined && value.toString().trim() !== '' && value.toString() !== '0') ? value : nullCheckValue;
	}
	public myfleetDownloadNullValueHandler(value: string): string
	{
		return value || '-';
	}
	public notApplicableValueHandler(value: string): string
	{
		return value || 'N/A';
	}
	public emptyStringHandler(value: string | undefined | null): string
	{
		return value ?? '';
	}
	public numericNullValueHandler(value: string): string
	{
		return value || '0';
	}
	public updateServiceCampaignBannerDataValue(message: string, tokenArray: TokenData[]): string
	{
		if (tokenArray && tokenArray.length > 0)
		{
			tokenArray.forEach((element) =>
			{
				if (element.isLink === 'true' && element.url !== '' )
				{
					element.text = `<a class="service-campaign-link" href='${element.url}' target='_blank'>` + element.text + '</a>';
					message = message.replace(element.name, element.text);
				}
				if(element.isLink === 'true' && element.url === '')
				{

					element.text = '<div class="link" tabindex="0">' + element.text + '</div>';
					message =  message.replace(element.name, element.text);

				}
				message =  message.replace(element.name, element.text);

			});
		}
		return message;
	}
	public updateBoldText(message: string, tokenArray: TokenData[]): string
	{
		if (tokenArray && tokenArray.length > 0)
		{
			tokenArray.forEach((element) =>
			{

				element.text = '<b>' + element.text + '</b>';

				message = message.replace(element.name, element.text);
			});
		}
		return message;
	}
	public static hasOneValidPrimitiveType(obj: SomeKeyValType, validatorPredicate: (value: PrimitiveType) => boolean = this.validatePrimitiveValue): boolean
	{
		let result: boolean = false;
		const primitiveTypes: ['number', 'string', 'boolean'] = [ 'number', 'string', 'boolean' ];
		lodashForIn(obj, item =>
		{
			const itemIsPrimitiveType: boolean = primitiveTypes.find(typeName => typeof item === typeName) !== undefined;
			result = itemIsPrimitiveType ? validatorPredicate(item) : this.hasOneValidPrimitiveType(item as unknown as SomeKeyValType, validatorPredicate);
			if (result)
			{
				return false;
			}
			else
			{
				return undefined;
			}
		});
		return result;
	}
	private static validatePrimitiveValue(item: PrimitiveType): boolean
	{
		const isValidString: boolean = typeof item === 'string' ? item !== '' : false;
		const isValidNumber: boolean = typeof item === 'number' && !Number.isNaN(item);
		const isValidBoolean: boolean = typeof item === 'boolean';
		return isValidString || isValidNumber || isValidBoolean;
	}

	public capitalizeFirstLetter(value: string)
	{
		let name = '';
		if (value)
		{
			name = value[0].toUpperCase() + value.substring(1);
		}
		return name;
	}

	public capitalizeFirstLetterOfEachWord(value: string )
	{
		if(value)
		{
			const str = value.split(' ');
			for(let i = 0; i < str.length; i++)
			{
				str[i] = str[i][0].toUpperCase() + str[i].substring(1);
			}
			return str.join(' ');
		}
		return value;
	}
	public createDownloadLink(blob: Blob, filename: string): void
	{
		const a = document.createElement('a');
		const objectUrl = URL.createObjectURL(blob);
		a.href = objectUrl;
		a.download = filename;
		a.click();
		URL.revokeObjectURL(objectUrl);
	}

	public downloadTable(name: string, res: Blob): string
	{
		const blob = new Blob([res], { type: 'text/csv;charset=utf8;' });
		this.date = new Date().toString();
		const filename = name + '_' + this.dateService.tranformDate(this.date, 'MMddyyyyhhmmss') + '.csv';
		this.createDownloadLink(blob, filename);
		return filename;
	}
	public downloadExcel(name: string, res: Blob): void
	{
		const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		const filename = name;
		this.createDownloadLink(blob, filename);
	}

	public downloadPDF(name: string, res: Blob): void
	{
		const blob = new Blob([res], { type: 'application/pdf' });
		const filename = name;
		this.createDownloadLink(blob, filename);
	}

	public downloadTableData(name: string, res: any, locationName?: string): string
	{
		let csvData = '';
		if(name === FileName.companyLocations)
		{
			const objArray: DownloadCompanyLocation[] = res;
			const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
			const tableHeader: string[]= Object.values(this.companyLocationsHeader);
			csvData = this.convertToCSV(array, tableHeader);
		}
		else if(name === FileName.bulkequipmentReport)
		{
			const objArray: DownloadReportTemp[] = res;
			const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
			let tableHeader: string[] = [];
			if(locationName === 'bulk')
			{
				tableHeader = Object.values(this.bulkEquipmentHeader);
			}
			else if(locationName === 'confirmBulk' || 'removeBulk')
			{
				const objArray: ReviewListDownloadTemp[] = res;
			    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
				tableHeader = Object.values(this.reviewListDownloadHeader);
			}
			else
			{
				tableHeader = Object.values(this.removeBulkEquipmentHeader);
			}
			csvData = this.convertToCSV(array, tableHeader);
		}
		else if(name === FileName.addBulkEquipmentToyotaDownloadReportTemplate)
		{
			const objArray: BulkEquipmentDownloadReportTemplate[] = res;
			const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
			const result = array.map(({ Log, ...rest }: { Log: any; [key: string]: any }) => ({ ...rest }));
			const tableHeader: string[]= Object.values(this.addBulkEquipmentDownloadReportTemplate);
			csvData = this.convertToCSV(result, tableHeader);
		}
		else if(name === FileName.addBulkEquipmentNonToyotaDownloadReportTemplate)
		{
			const objArray: BulkEquipmentNonToyotaDownloadReportTemplate[] = res;
			const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
			const result = array.map(({ Log, ...rest }: { Log: any; [key: string]: any }) => ({ ...rest }));
			const tableHeader: string[]= Object.values(this.addBulkEquipmentNonToyotaDownloadReportTemplate);
			csvData = this.convertToCSV(result, tableHeader);
		}
		else if(name === FileName.assignUserList)
		{
			const objArray: DownloadUserListData[] = res;
			const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
			const tableHeader: string[]= Object.values(this.assignedUserTableHeader);
			csvData = this.convertToCSV(array, tableHeader);
			name = locationName + '_' + name;
		}
		else if(name === FileName.inviteUserTemplate)
		{
			const objArray = res;
			const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
			let tableHeader: string[] = [];
			if(locationName === 'bulk')
			{
				tableHeader = Object.values(this.inviteBulkUserheader);
			}
			else
			{
				tableHeader = Object.values(this.inviteUserheader);
			}
			csvData = this.convertToCSV(array, tableHeader);
		}
		csvData = '\uFEFF' + csvData;
		const blob = new Blob([csvData], { type: 'data:text/csv;charset=utf-8;' });
		this.date = new Date().toString();
		const filename = name + '_' + this.dateService.tranformDate(this.date, 'MMddyyyyhhmmss') + '.csv';
		this.createDownloadLink(blob, filename);
		return filename;
	}


	public convertToCSV(array: any[], tableHeader: string[])
	{
		let str = '';
		let row = '';
		tableHeader.forEach((element: string) =>
		{
			row += element.concat(',');
		});
		row = row.slice(0, -1);
		str += row.concat('\r\n');

		for (const i in array)
		{
			let line = '';
			for (const index in array[i])
			{

				if (line !== '') line += ',';

				line += array[i][index];
			}
			str += line + '\r\n';
		}
		return str;
	}

	public formatAddress(address: Address| undefined, formatCompleteAddress: boolean)
	{
		if (formatCompleteAddress)
		{
			return [ address?.addressLine1, address?.addressLine2, address?.city, address?.state, address?.zipCode ].filter(Boolean).join(', ');
		}
		else
		{
			return [ address?.city, address?.state, address?.zipCode ].filter(Boolean).join(', ');
		}
	}

	public formatAddressWithPostalCode(address: ResponseDealerAddress | undefined)
	{
		return [ address?.address1, address?.address2, address?.city, address?.stateCode, address?.postalCode ].filter(Boolean).join(', ');
	}

	public getAssignedLocationFormatted(): AssignedLocation[]
	{

		const locations: LoggedInLocation[] = this.getLoggedInUserLocations();
		const assignedLocations: AssignedLocation[] = [];
		locations.forEach(element =>
		{
			const location: AssignedLocation = { name: element.locationName, id: element.locationId, address: element.address, companyId: element.companyId };
			assignedLocations.push(location);
		});
		return assignedLocations;
	}

	public async assignedLocationSearch(searchKey: string): Promise<AssignedLocation[]>
	{
		const locationData = this.getAssignedLocationFormatted();
		if (searchKey && searchKey.length > 2)
		{
			const filteredResult: AssignedLocation[] = locationData.filter(
				(location: AssignedLocation) =>
				{
					return location.name.toLowerCase().includes(searchKey.toLowerCase()) ||
					(location.address?.addressLine1?.toLowerCase().includes(searchKey.toLowerCase()) ||
					location.address?.addressLine2?.toLowerCase().includes(searchKey.toLowerCase()) ||
					location.address?.city?.toLowerCase().includes(searchKey.toLowerCase()) ||
					location.address?.state?.toLowerCase().includes(searchKey.toLowerCase()) ||
					location.address?.zipCode?.toLowerCase().includes(searchKey.toLowerCase())
					);
				}
			);
			return Promise.resolve<AssignedLocation[]>(filteredResult);
		}
		else
		{
			return Promise.resolve<AssignedLocation[]>([]);
		}
	}
	public checkIfLocationExists(locationName: string): boolean
	{
		const locationArray = this.getLoggedInUserLocations();
		return locationArray.filter((location: LoggedInLocation) => location.locationName.toLowerCase() === locationName.toLowerCase()).length > 0;
	}

	public getCustomerId()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.localStorageService.parseJSON(userProfile).customerIds;
		}
	}
	public getUserId()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.localStorageService.parseJSON(userProfile).userId;
		}
	}
	getDefaultGrid()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.localStorageService.parseJSON(userProfile).defaultGRID? this.localStorageService.parseJSON(userProfile).defaultGRID : '';
		}
	}
	getLocalstorageItems()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		let loggedinUser: LoggedInUser;
		if (userProfile)
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			if (loggedinUser)
			{
				this.coperateConvertFlag = loggedinUser.corporateAccountRequestFlag;
			}


		} return this.coperateConvertFlag;
	}
	getLocalstorageUserProfile()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.localStorageService.parseJSON(userProfile);
		}
	}
	public getUserEmail()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.localStorageService.parseJSON(userProfile).email;
		}
	}
	public getPhoneNumber()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.emptyStringHandler(this.localStorageService.parseJSON(userProfile).phoneNumber);
		}
		else
			return '';
	}
	public 	getRoleId()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.localStorageService.parseJSON(userProfile).roles[0];
		}
	}
	public getPrivacyDate()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.nullDateHandler(this.localStorageService.parseJSON(userProfile).privacyDate);
		}
		else
		{
			return nullCheckValue;
		}
	}
	public getTcDate()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile)
		{
			return this.nullDateHandler(this.localStorageService.parseJSON(userProfile)?.tcDate);
		}
		else
		{
			return nullCheckValue;
		}
	}

	public requiredLength(control: AbstractControl)
	{
		const val: string = control.value?.split(/\W+/).join('');
		const err: boolean = val?.trim().length < 1;
		if (err)
		{
			return { requiredLen: { value: control.value } };
		}
		else
		{
			return null;
		}
	}

	alphaSpecialCharValidation(control: AbstractControl, name: string)
	{
		const regex = name === 'city'?  /^[a-zA-ZáéíóúýàèìòùêëîïûüñçœâôÿÀÂÆÇÉÈÊËÎÏÔŒÙÛÜŸ!#$%&'"’–()*+,-./\\:;<=>?@[\]^_`{|}~ ]+$/ : /^[a-zA-Z0-9áéíóúýàèìòùêëîïûüñçœâôÿÀÂÆÇÉÈÊËÎÏÔŒÙÛÜŸ!#$%&'"’–()*+,-./\\:;<=>?@[\]^_`{|}~ ]+$/;
		const value = control.value;

		return (value?.length>0 && !regex.test(value)) ? { alphaSpclCharValidationError: { value: control.value } } : null;
	}

	nonNumericSpaceRestriction(value: string)
	{
		if (value.trim())
		{
			const regex = /\d+/;
			const address = value.replace(regex, '');
			return address.trimLeft();
		}
		return value.trim();
	}

	characterValidationWithNumerics(control: AbstractControl)
	{
		const regex = /^[a-zA-Z0-9\s,-.']+$/;
		const value = control.value;
		return (value?.length>0 && !regex.test(value)) ? { invalidCharacterError: { value: control.value } } : null;
	}

	characterValidationWithoutNumerics(control: AbstractControl)
	{
		const regex = /^[a-zA-Z\s,-.']+$/;
		const value = control.value;
		return (value?.length>0 && !regex.test(value)) ? { invalidCharacterError: { value: control.value } } : null;
	}

	zipCodeLengthCheck(control: AbstractControl)
	{
		const value = control.value;
		return (value?.length > 0 && value?.length < 5) ? { minLengthError: { value: control.value } } : null;
	}

	zipCodeCanadaValidCheck(control: AbstractControl)
	{
		const regex = canadaZipFormat;
		const value = control.value;
		return (value?.length>0 && !regex.test(value)) ? { canadaPostalCodeFormatError: { value: control.value } } : null;
	}

	noWhitespaceValidator(control: AbstractControl)
	{
		const isWhitespace = (control.value || '').trim().length === 0;
		const isValid = !isWhitespace;
		return isValid ? null : { whitespace: true };
	}

	updateMessage(message: string, token: string, replaceText: string)
	{
		return message.replace(token, replaceText);
	}

	public validatePhoneSequence(control: AbstractControl): { sequence: boolean } | null
	{
		if(control.value)
		{
			const value = control.value?.split(/\W+/).join('');
			let next = parseInt(value[0]) + 1;
			let seq = true;
			for (const letter of value.slice(1).split(''))
			{
				if (next !== parseInt(letter))
				{
					seq = false;
					break;
				}
				else if (next === 9)
				{
					next = 0;
				}
				else
				{
					next++;
				}
			}

			return seq ? { sequence: true } : null;
		}
		else
		{
			return null;
		}
	}
	public minLength(control: AbstractControl)
	{
		if(control.value !== undefined && control.value !== '')
		{
			const val: string = control.value?.split(/\W+/).join('');
			const err: boolean = val?.trim().length > 0 && val?.trim().length < 10;
			if (err)
			{
				return { minLength: { value: control.value } };
			}
			else
			{
				return null;
			}
		}
		else
		{
			return null;
		}
	}

	public formatString(value: string): string
	{
		if (value.trim())
		{
			const userName = value.replace(/[^a-zA-Z0-9 ]/g, '');
			return userName;
		}
		return value.trim();
	}
	public getRequestServicePath()
	{
		return this.environmentRef.openContactFormUrl;
	}

	public currencyFormatter(amount: number, currency: string)
	{
		return new Intl.NumberFormat(LanguageCode.default, {
			style: 'currency',
			currency: currency,
			maximumFractionDigits: 0
		}).format(amount);
	}
	concatenateLocation(location: Address): string
	{
		let concateLocation = '';
		if (location)
		{
			concateLocation = [ location.addressLine2, location.city, location.state, location.zipCode ]
				.filter(Boolean)
				.join(', ');
		}
		return concateLocation;
	}

	public round(value: number, precision: number)
	{
		return (Math.floor(value * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed( precision);
	}
	isEmptyObject(obj: any): boolean
	{
		return (obj && (Object.keys(obj).length === 0));
	}
	getLoggedInUserCompanyObs()
	{
		let loggedinUser: LoggedInUser;
		const userProfile = this.localStorageService.getLoggedInUser();
		let company: string = '';
		if (userProfile)
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			if (loggedinUser && !this.isEmptyObject(loggedinUser))
			{
				company = loggedinUser.company;
			}
			return of(company);
		}
		else
		{
			return this.apiService.getLoggedInUserObs().pipe(
				map(response => (response.statusCode === 200) ? this.processCompanyId(response) : company)
			);
		}
	}
	processCompanyId(res: ApiResponse): string
	{
		const user: AuthState = <AuthState>res.data;
		let companyId: string = '';
		if (user.company)
			companyId = user.company;
		return companyId;
	}
	getLoggedInUserAdminLocationIdObs()
	{
		let loggedinUser: LoggedInUser;
		const userProfile = this.localStorageService.getLoggedInUser();
		let adminLocationId: string = '';
		if (userProfile)
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			if (loggedinUser && !this.isEmptyObject(loggedinUser))
			{
				adminLocationId = loggedinUser.adminLocationID ? loggedinUser.adminLocationID : '';
			}
			return of(adminLocationId);
		}
		else
		{
			return this.apiService.getLoggedInUserObs().pipe(
				map(response => (response.statusCode === 200) ? this.processAdminLocationId(response) : adminLocationId)
			);
		}
	}
	processAdminLocationId(res: ApiResponse): string
	{
		const user: AuthState = <AuthState>res.data;
		let adminLocationId: string = '';
		if (user.adminLocationID)
			adminLocationId = user.adminLocationID;
		return adminLocationId;
	}
	processAdminEmailId(res: ApiResponse): string
	{
		const user: AuthState = <AuthState>res.data;
		let adminEmailId: string = '';
		if (user.adminEmailId)
			adminEmailId = user.adminEmailId;
		return adminEmailId;
	}
	getLoggedInUserLocations(): LoggedInLocation[]
	{
		let loggedinUser: LoggedInUser;
		let loggedInLocations: LoggedInLocation[] = [];
		const userProfile = this.localStorageService.getLoggedInUserLocation();
		if (userProfile && !this.isEmptyObject(userProfile))
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			if (loggedinUser && !this.isEmptyObject(loggedinUser) && loggedinUser.locations?.length > 0)
			{
				loggedInLocations = loggedinUser.locations;
			}
		}

		return loggedInLocations;
	}
	public getuserNameObs(): Observable<string>
	{
		const userProfile = this.getUserProfile();
		let userName = '';

		if (userProfile && !this.isEmptyObject(userProfile))
		{
			userName = this.constructUserName(userProfile);
			return of(userName);
		}
		else
		{
			const userObs: Observable<ApiResponse> = this.getUserObservable();
			return userObs.pipe(
				map(response => (response.statusCode === 200) ? this.processUserName(response) : userName)
			);
		}
	}

	private getUserProfile(): any
	{
		return this.sharedUtilService.isTmhCorporateAdmin && !this.sharedUtilService.isCustomerSupportSession ?
			this.localStorageService.getTmhCorporateAdminDetails()  :
			this.sharedUtilService.isTmhCustomerSupportRole && !this.sharedUtilService.isCustomerSupportSession ?
				this.localStorageService.getTmhCustomerSupportDetails() :
				this.localStorageService.getLoggedInUser();
	}

	private constructUserName(userProfile: any): string
	{
		const parsedProfile = this.localStorageService.parseJSON(userProfile);
		return `${parsedProfile?.firstName} ${parsedProfile?.lastName}`;
	}

	private getUserObservable(): Observable<ApiResponse>
	{
		return this.sharedUtilService.isTmhCorporateAdmin ?
			this.apiService.getLoggedInTmhCorporateAdminDetails() :
			this.sharedUtilService.isTmhCustomerSupportRole && !this.sharedUtilService.isCustomerSupportSession ?
				this.apiService.getLoggedInTmhCustomerSupportDetails() :
				this.apiService.getLoggedInUserObs();
	}
	processUserName(res: ApiResponse): string
	{
		let loggedInUser: string = '';
		const user: AuthState = <AuthState>res.data;
		loggedInUser = this.capitalizeFirstLetter(user?.firstName)
			+ ' ' + this.capitalizeFirstLetter(user?.lastName);
		return loggedInUser;
	}
	getLoggedInUseLocationsIdsObs(): Observable<string[]>
	{
		let loggedinUser: LoggedInUser;
		let loggedInLocationIds: string[] = [];
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile && !this.isEmptyObject(userProfile))
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			if (loggedinUser && !this.isEmptyObject(loggedinUser) && loggedinUser.customerIds?.length > 0)
			{
				loggedInLocationIds = [...loggedinUser.customerIds].filter(val => val!== null);

			}
			return of(loggedInLocationIds);
		}
		else
		{
			return this.apiService.getLoggedInUserObs().pipe(
				map(response => (response.statusCode === 200) ? this.process(response) : loggedInLocationIds)
			);
		}

	}

	process(res: ApiResponse): string[]
	{
		let loggedInLocationIds: string[] = [];
		const user: AuthState = <AuthState>res.data;
		loggedInLocationIds = [...user.customerIds].filter(val => val!== null);
		return loggedInLocationIds;
	}
	getLoggedInUserLocationWithPrimaryGridObs(): Observable<LocationPrimaryGrid>
	{
		let loggedinUser: LoggedInUser;
		const loggedInLocationPrimaryGrid: LocationPrimaryGrid = { locations: [], primaryGridId: '' };
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile && !this.isEmptyObject(userProfile))
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			if (loggedinUser && !this.isEmptyObject(loggedinUser) && loggedinUser.customerIds.length > 0)
			{
				loggedInLocationPrimaryGrid.primaryGridId = loggedinUser.primaryLocationGRID;
				loggedInLocationPrimaryGrid.locations = [...loggedinUser.customerIds].filter(val => val!== null);
			}
			return of(loggedInLocationPrimaryGrid);
		}
		else
		{
			return this.apiService.getLoggedInUserObs().pipe(
				map(response => (response.statusCode === 200) ? this.processPrimaryGridId(response) : loggedInLocationPrimaryGrid)
			);
		}

	}
	processPrimaryGridId(res: ApiResponse): LocationPrimaryGrid
	{
		const loggedInPrimaryGrid: LocationPrimaryGrid = { locations: [], primaryGridId: '' };
		const user: AuthState = <AuthState>res.data;
		if(user.customerIds)
		{
			loggedInPrimaryGrid.locations = [...user.customerIds].filter(val => val!== null);
		}
		loggedInPrimaryGrid.primaryGridId = user?.primaryLocationGRID ? user?.primaryLocationGRID : '';
		return loggedInPrimaryGrid;
	}

	public getLocationValues(): Control[]
	{
		const locations: LoggedInLocation[] = this.getLoggedInUserLocations();
		const assignedLocations: Control[] = [];
		const assignedLocationArr: string[] = [];
		locations.forEach(element =>
		{
			const location: AssignedLocation = {
				name: element?.locationLabel ? element.locationLabel : element.locationName,
				id: element.locationId,
				address: element.address
			};
			assignedLocations.push(
				this.initialiseFilterControl(
					location.id,
					location.name,
					ControlType.checkbox,
					location.address
				)
			);
			assignedLocationArr.push(location.name);
		});
		this.locationNames = [...assignedLocations];
		this.locationNamesArr = [...assignedLocationArr];
		return assignedLocations;
	}

	public getBillingLocationValues(): Control[]
	{
		const locations: LoggedInLocation[] = this.getLoggedInUserLocations();
		const assignedLocations: Control[] = [];
		const assignedLocationArr: string[] = [];
		locations.forEach(element =>
		{
			const location: AssignedLocation = {
				name: element?.locationLabel ? element.locationLabel : element.locationName,
				id: element.locationId,
				address: element.address
			};
			assignedLocations.push(
				this.initialiseFilterControl(
					location.id,
					location.name,
					ControlType.checkbox,
					location.address
				)
			);
			assignedLocationArr.push(location.name);
		});
		this.locationNames = [...assignedLocations];
		this.locationNamesArr = [...assignedLocationArr];
		return assignedLocations;
	}
	initialiseFilterControl(id: string, label: string, type: ControlType, address?: Address)
	{
		return new Control({
			id: id,
			label: label,
			type: type,
			value: false,
			isLocation: (address !== undefined),
			address: address,
			inputPlaceholderText: '',
			inputIcon: '',
			options: []
		});
	}

	initialiseServiceFilterControl(id: string, label: string, type: ControlType, address?: ServiceManagementAddress)
	{
		return new Control({
			id: id,
			label: label,
			type: type,
			value: false,
			isLocation: (address !== undefined),
			address: address,
			inputPlaceholderText: '',
			inputIcon: '',
			options: []
		});
	}

	requestServiceEquipmentDetails()
	{
		if (this.environmentRef.requestServiceEquipmentDetails)
		{
			window.open(this.environmentRef.requestServiceEquipmentDetails, '_blank', 'noopener');
		}
	}

	public displayRepairLines(key: string, value: [{ repairType: string; repairCode: string }], gridObj: KngValueObjState, labels: GridModel | ServiceHistoryLabels)
	{
		const valueKeys = Object.keys(value[0]);
		const repairtypeArr: string[] = [];
		const repaircodeArr: string[] = [];
		value.forEach((repairLine: { repairType: string; repairCode: string }) =>
		{
			repairtypeArr.push(repairLine.repairType);
			repaircodeArr.push(repairLine.repairCode);
		});
		const uniqueRepairtype = new Set(repairtypeArr);
		let uniqueRepairtypeArr = [...uniqueRepairtype];
		const uniqueRepaircode = new Set(repaircodeArr);
		let uniqueRepaircodeArr = [...uniqueRepaircode];
		uniqueRepairtypeArr = uniqueRepairtypeArr.filter(item => item !== '');
		uniqueRepaircodeArr = uniqueRepaircodeArr.filter(item => item !== '');
		this.setRepairtype(valueKeys, uniqueRepairtypeArr, key, gridObj, labels);
		this.setRepaircode(valueKeys, uniqueRepaircodeArr, key, gridObj, labels);
		return gridObj;
	}

	public getLabel(dataKey: string, labels: GridModel | ServiceHistoryLabels | ChangeRequestHeaderLabel | MyQuotesGridListLabel | ReviewListHeader): string
	{
		let label = '';
		Object.entries(labels).forEach(([ key, value ]) =>
		{
			if (key === dataKey) label = value;
		});
		return label;
	}

	public setRepairtype(valueKeys: string[], uniqueRepairtypeArr: string[], key: string, gridObj: KngValueObjState, labels: GridModel | ServiceHistoryLabels)
	{
		const repairtypelabel = this.getLabel(valueKeys[0], labels);
		if (uniqueRepairtypeArr.length <= 1 && repairtypelabel !== '')
		{
			gridObj.values.push(this.setRepairLine(repairtypelabel, uniqueRepairtypeArr, key));
		}
		else if (uniqueRepairtypeArr.length > 1 && repairtypelabel !== '')
		{
			gridObj.values.push(this.setRepairLineMultiple(repairtypelabel, uniqueRepairtypeArr, key));
		}
		return gridObj;
	}
	public setRepaircode(valueKeys: string[], uniqueRepaircodeArr: string[], key: string, gridObj: KngValueObjState, labels: GridModel | ServiceHistoryLabels)
	{
		const repaircodelabel = this.getLabel(valueKeys[1], labels);
		if (uniqueRepaircodeArr.length <= 1 && repaircodelabel !== '')
		{
			gridObj.values.push(this.setRepairLine(repaircodelabel, uniqueRepaircodeArr, key));
		}
		else if (uniqueRepaircodeArr.length > 1 && repaircodelabel !== '')
		{
			gridObj.values.push(this.setRepairLineMultiple(repaircodelabel, uniqueRepaircodeArr, key));
		}
		return gridObj;
	}
	public setRepairLine(label: string, array: string | string[], key: string)
	{
		const valueState: KngValueListState = {
			label: label,
			labelValue: array[0],
			icon: '',
			cssClass: '',
			category: this.checkCategory(key)
		};
		return valueState;
	}
	public setRepairLineMultiple(label: string, array: string | string[], key: string)
	{
		const valueState: KngValueListState = {
			label: label,
			labelValue: array.length.toString() + ' ' + label + 's',
			icon: '',
			cssClass: '',
			category: this.checkCategory(key)
		};
		return valueState;
	}
	public checkCategory(key: string): string
	{
		let selectedCat: string = FieldType.text;
		selectedCat = (key === FieldName.status) ? FieldType.invoice : this.sharedUtilService.getFieldType(key);
		return selectedCat;
	}
	public getadminEmail()
	{
		const userProfile = this.localStorageService.getLoggedInUser();
		let loggedinUser: LoggedInUser;
		let adminEmailId: string = '';
		if (userProfile)
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			if (loggedinUser && !this.isEmptyObject(loggedinUser))
			{
				adminEmailId = loggedinUser.adminEmailId ? loggedinUser.adminEmailId : '';
			}
			return of(adminEmailId);
		}
		else
		{
			return this.apiService.getLoggedInUserObs().pipe(
				map(response => (response.statusCode === 200) ? this.processAdminEmailId(response) : adminEmailId)
			);
		}

	}

	public triggerErrorService(status: string, statusCode: number, id:string) 
	{ 
		const image: Image = this.sharedUtilService.setImageBasedOnStatusCode(statusCode);
		const roleId = this.getRoleId();
		const contactMessage: string = (roleId === individualUserRoleId) ? individualUserPermissionMessage :
			(roleId === accountManagerRoleId) ? '' : this.updateGetAdminEmail(this.sharedUtilService.getMessage()) + '.';
		this.errorService.updateState({ messages: [{ message: status }, { message: contactMessage, cssClass: 'error-contact-section' }], statusCode: statusCode, id: id, image: image });
	}

	public updateGetAdminEmail(message: Message): string
	{
		this.getadminEmail().subscribe({
			next: (res: string) =>
			{
				message.tokens = [];
				const token: Token = { name: '$token', text: res, isLink: true };
				message.tokens.push(token);

				if (message.tokens && message.tokens.length > 0)
				{
					message.tokens.forEach((element) =>
					{
						message.text = message.text?.replace(element.name, element.text);
					});
				}
			}

		});
		return message.text;
	}

	checkRouteParams(label: string, querParams:{[key: string]: string })
	{
		if(label === BreadCrumb.addNewLocation && querParams?.['locationId'])
		{
			label = BreadCrumb.locationDetails;
		}
		return label;
	}

	getLoggedInUserRole(): Observable<string[]>
	{
		const loggedInRoleName: string[] = [];
		return this.apiService.getLoggedInUserObs().pipe(
			map(response => (response.statusCode === 200) ? this.processRoleName(response) : loggedInRoleName)
		);

	}

	getLoggedInUserRoleFromSession(): Observable<string[]>
	{
		let loggedinUser: LoggedInUser;
		const role: string[] = [];
		const userProfile = this.localStorageService.getLoggedInUser();

		if (userProfile && !this.isEmptyObject(userProfile))
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);

			if (loggedinUser && !this.isEmptyObject(loggedinUser))
			{
				loggedinUser.roles?.forEach((item: string) =>
				{
					role.push(item);
				});

			}
			return of(role);
		}
		else
		{
			return this.apiService.getLoggedInUserObs().pipe(
				map(response => (response.statusCode === 200) ? this.processRole(response) : role)
			);
		}

	}

	processRole(res: ApiResponse): string[]
	{
		const role: string[] = [];
		const user: AuthState = <AuthState>res.data;
		user.roles?.forEach((item: string) =>
		{
			role.push(item);
		});
		return role;
	}

	processRoleName(res: ApiResponse): string[]
	{
		const user: AuthState = <AuthState>res.data;
		const loggedInRoleName: string[] = user.roles? user.roles : [];

		return loggedInRoleName;
	}

	getErrorState(message: string, contactMessage: Message)
	{
		const errorState:CommonErrorState = {
			messages: [{ message: message }, { message: this.updateGetAdminEmail(contactMessage), cssClass: 'error-contact-section' }],
			id: '',
			statusCode: 401,
			image: this.sharedUtilService.setImageBasedOnStatusCode(401)
		};

		return errorState;
	}
	checkForIndividualUserRole(roleList: Role[])
	{
		const indexOfIndividualRole = roleList.findIndex(role=> role.id === individualUserRoleId);
		if(indexOfIndividualRole !== -1)
		{
			roleList.splice(indexOfIndividualRole, 1);
		}
		return roleList;
	}
	formatPhoneNumber(value: string): string
	{
		if(value.trim())
	   {
			let phoneNumber = value.replace(/[^\d]/g, '');
			const phoneNumberLength = phoneNumber.length;
			phoneNumber = phoneNumberLength > 10 ? phoneNumber.slice(-10) : phoneNumber;
			if (phoneNumberLength < 4) return phoneNumber;
			if(phoneNumberLength < 7)
		   return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3)}`;
			return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(
				3, 6
			)}-${phoneNumber.slice(6, 10)}`;
	   }
	   return value.trim();
	}
	handlePhoneInputCursor(event: Event, cursorPosition: number, formattedNumberLength: number)
	{
		const inputEvent = event as InputEvent;
		if(this.isCursorAtFormattedValues(cursorPosition, formattedNumberLength, inputEvent) )
		{
			cursorPosition = cursorPosition+2;
		}
		else if([ 1, 4, 8 ].includes(cursorPosition) && inputEvent.inputType !== 'deleteContentBackward')
		{
			cursorPosition = cursorPosition + 1;
		}
		return cursorPosition;
	}
	isCursorAtFormattedValues(cursorPosition: number, formattedNumberLength: number, inputEvent: InputEvent)
	{
		return this.isSequentialInput(cursorPosition, formattedNumberLength, 1, 2) || this.isSequentialInput(cursorPosition, formattedNumberLength, 4, 7) || (this.isSequentialInput(cursorPosition, formattedNumberLength, 9, 11) && inputEvent.inputType !== 'deleteContentBackward');
	}
	isSequentialInput(cursorPosition: number, formattedNumberLength: number, index: number, length: number)
	{
		return (cursorPosition === index && formattedNumberLength <= length);
	}
	getRoleIdArrObs(): Observable<string[]>
	{
		let loggedinUser: LoggedInUser;
		let roleIDArr: string[] = [];
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile && !this.isEmptyObject(userProfile))
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			roleIDArr = (loggedinUser && !this.isEmptyObject(loggedinUser) && loggedinUser.roles) ?  loggedinUser.roles : [];
			return of(roleIDArr);
		}
		else
		{
			return this.apiService.getLoggedInUserObs().pipe(
				map(response => (response.statusCode === 200) ? this.processRoleIDArr(response) : roleIDArr)
			);
		}

	}
	processRoleIDArr(res: ApiResponse): string[]
	{
		let roleIDArr: string[] = [];
		const user: AuthState = <AuthState>res.data;
		roleIDArr = user.roles? user.roles : [];
		return roleIDArr;
	}

	getLoggedInUserObs(): Observable<LoggedInUser>
	{
		let loggedinUser: LoggedInUser;
		const userProfile = this.localStorageService.getLoggedInUser();
		if (userProfile && !this.isEmptyObject(userProfile))
		{
			loggedinUser = this.localStorageService.parseJSON(userProfile);
			return of(loggedinUser);
		}
		else
		{
			return this.apiService.getLoggedInUserObs().pipe(
				map(response => (response.statusCode === 200) ? this.processLoggedInUser(response) : loggedinUser)
			);
		}

	}

	getLoggedInUserLocationsObservable(): Observable<LoggedInLocation[]>
	{
		return of(this.getLoggedInUserLocations());
	}

	processLoggedInUser(res: ApiResponse): LoggedInUser
	{
		const user: LoggedInUser = <LoggedInUser>res.data;
		return user;
	}
	nullAddressHandler(location: Address, notApplicableValueHandler: boolean = false): Address
	{
		const address: Address = {
			addressLine1: '',
			addressLine2: '',
			city: '',
			state: '',
			zipCode: ''
		};
		if(this.isEmptyAddress(location))
		{
			address.addressLine1 = notApplicableValueHandler? this.notApplicableValueHandler('') : this.nullValueHandler('');
		}
		else
		{
			address.addressLine1 = this.emptyStringHandler(location.addressLine1);
			if(location.addressLine2)
				address.addressLine2 = this.emptyStringHandler(location.addressLine2);
			address.city = this.emptyStringHandler(location.city);
			address.state = this.emptyStringHandler(location.state);
			address.zipCode = this.emptyStringHandler(location.zipCode);
		}
		return address;
	}

	isEmptyAddress(location: Address)
	{
		return (!location || (!location.addressLine1 && !location.addressLine2 && !location.city && !location.state && !location.zipCode));
	}

	isStateCityPresent(city: string, state: string)
	{
		if(city && state)
		{
			return (city + ', ' + state);
		}
		else if(city)
		{
			return city;
		}
		return state || '' ;
	}

	checkCountryCode(countryCode: string)
	{
		if(countryCode.toLocaleUpperCase() === CountryCode.unitedStates || countryCode.toLocaleUpperCase() === CountryCode.unitedStatesofAmerica || countryCode.toLocaleUpperCase() === CountryCode.unitedStatesFull )
		{
			return CountryCode.unitedStatesofAmerica;
		}
		else if(countryCode.toLocaleUpperCase() === CountryCode.canada || countryCode.toLocaleUpperCase() === CountryCode.canadaCountry)
		{
			return CountryCode.canadaCountry;
		}
		return '';
	}

	formatUserName(firstName: string, lastName: string | undefined)
	{
		if(firstName && lastName)
		{
			return (firstName + ' ' + lastName);
		}
		else if(firstName)
		{
			return firstName;
		}
		return lastName ?? '' ;
	}

	public navigateMethod(router : Router, path: string | undefined, params?: string | undefined | boolean | number)
	{
		if(params)
		{
			router.navigate([path+'/'+params])?.then(succeeded =>
			{
				if(succeeded)
				{
					this.loggerService.log('navigation succeeded');
				}

			})
				.catch(error =>
				{
					this.loggerService.error(error);
				});;
		}
		else
		{
			router.navigate([path])?.then(succeeded =>
			{
				if(succeeded)
				{
					this.loggerService.log('navigation succeeded');
				}

			})
				.catch(error =>
				{
					this.loggerService.error(error);
				});
		}
	}

	public validateStringUnique(control: AbstractControl)
	{
		if(control.value)
		{
	    const value = control.value?.split(/\W+/).join('');
			const firstNum = value ? value[0] : '';
			let uniq = true;
			for (const letter of value.split(''))
			{
				if (letter !== firstNum)
				{
					uniq = false;
					break;
				}
			}
			return uniq ? { unique: true } : null;
		}
		else
		{
			return null;
		}
	}
	checkTableSort(event: KngHeaderObjState, headerName:any)
	{
  	let field: string = '';
		const labels=Object.keys(headerName);
		const labelValues = Object.values(headerName);
	  for (let i = 0; i < labels.length; i++)
	  {
		  if (event.label === labelValues[i])
		  {
			  field = labels[i];
		  }
	  }
  	const sortPayload = {
  		field: field,
  		order: event.sortOrder === SortOrder.asc ? SortOrder.asc : SortOrder.desc
  	};
	  return sortPayload;
	}


	public getStateProvinceValues(country: string): StateProvince[]
	{
		if(country.includes(CountryCode.unitedStates))
		{
			return states;
		}
		else if(country.includes(CountryCode.canada))
		{
			return provinces;
		}
		return [];
	}

	public isInvalidLength(searchData: string)
	{
		return searchData?.replace(/\s/g, '').trim().length > 0 && searchData?.replace(/\s/g, '').trim().length < 4;
	}

	public getValidateRemoveLocResponse(removeLocResponse: ApiResponse)
	{
		const responseObj: ValidateRemoveLocResponse = <ValidateRemoveLocResponse>(removeLocResponse.data);
		this.validateRemoveLocResponse.isLastLocation = responseObj.isLastLocation;
		this.validateRemoveLocResponse$.next(true);
	}

	public validateRemoveLocError(error: HttpErrorResponse)
	{
		this.loggerService.log(error.error.message);
		this.validateRemoveLocResponse$.next(false);
	}


	nullHandlerCheck(key: string, value: string)
	{
		let updatedVal: string = '';
		if(key === FieldName.location || key === FieldName.assignedLocation )
		{
			updatedVal = this.nullLocationHandler(value);
		}
		else if(key === FieldName.telematicsStatus)
		{
			updatedVal = value;
		}
		else if(key === FieldName.batteryStateOfCharge && ((value === null) || (value === undefined) || (value === '')))
		{
			updatedVal = batteryStateOfChargeNullValue;
		}
		else
		{
			updatedVal = this.nullValueHandler(value);
		}
		return updatedVal;
	}

	public scrollToTopOfPage()
	{
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		  });
	}
	getEmailAddress()
	{
		const portalUser = this.localStorageService.getLoggedInUser();
		const corporateAdmin = this.localStorageService.getTmhCorporateAdminDetails();
		if (portalUser)
		{
			return this.localStorageService.parseJSON(portalUser).email ?? '';
		}
		else if(corporateAdmin)
		{
			return this.localStorageService.parseJSON(corporateAdmin)?.email ?? '';
		}
		return '';
	}
	customerServiceMail(errorMessage:string)
	{
		const mail='customerservice@toyotatmh.com';
		const subMessage=/Toyota Customer Service/g;
		const message=errorMessage.replace(subMessage, `<a  class="toyota-mail-link"  href="mailto:${mail}">Toyota Customer Service</a>` );
		return message;
	}

	public modifySearchString(searchData: string)
	{
    	const searchedCap = searchData.trimStart().toUpperCase();
    	return searchedCap;
	}
	getDefaultKngHeaderObjState() 
	{
		return {
			label: '',
			isSort: false,
			sortOrder: SortOrder.asc
		};
	}

	getDefaultKngValueObjState(): KngValueObjState 
	{
		return {
			collapsed: false,
			values: [],
			id: ''
		};
	}

	getDefaultvalueListState(key: string, value: string)
	{
		return {
			id: '',
			label: key,
			labelValue: value,
			icon: '',
			cssClass: '',
			category: '',
			isTooltipPresent: false,
			tooltip: { closeIcon: SharedFactoryDataService.buildImage(Icons.toolTipCloseIcon, ''), content: '' }
		};
	}

}
